<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="项目名称：" prop="deviceNo">
                <span>{{model.project_name}}</span>
            </el-form-item>
            <el-form-item label="设备类型：" prop="device_type">
                <span>{{ transEnu(model.device_type, "device_type") }}</span>
            </el-form-item>
            <el-form-item label="设备编号：" prop="deviceNo">
                <span>{{model.device_code}}</span>
            </el-form-item>
            <el-form-item label="通道编号：" prop="channelNo">
                <span>{{model.channel_no}}</span>
            </el-form-item>
            <el-form-item label="告警类型：" prop="groutType">
                <span>{{ transEnu(model.alert_type, "alert_type") }}</span>
            </el-form-item>
            <el-form-item label="所在位置：" prop="name">
                <span>{{model.location}}</span>
            </el-form-item>
            <el-form-item label="警告值：" prop="value">
                <span>{{model.value}}</span>
            </el-form-item>
            <el-form-item label="警告时间：" prop="datetime">
                <span>{{model.datetime}}</span>
            </el-form-item>
            <el-form-item label="告警用户：" prop="member_id">
                <span>{{model.user_name}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'alertMsgInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                deviceNo: '',
                channelNo: '',
                groutType: '',
                type: '',
                name: '',
                value: '',
                datetime: '',
                msg_str: '',
                member_id: '',
            },
            getObj:{
                url:'/api/admin/alertmsg/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['alert_type', 'device_type'],
        };
    },
    methods: {}
};
</script>